import {Init} from '@/core/Init'
import {Attachable} from '@/core/items/base/Attachable'
import {APP_EVT, CONST, SERIES_ID, APP_LOCATION, APP_ROLE} from '@/core/config/constants'
import {Debug} from '@/core/util/Debug'
import {DesignData} from '@/core/main/Interface'
import {ITEM_TYPE} from '@/core/config/constants'

import * as svgjs from '@svgdotjs/svg.js'

class DataBase {

	public _stage: svgjs.Container;

	constructor() {

		this._stage = Init.svg_stage;

		Init.emitter.on(APP_EVT.RETRIEVE_DESIGN, this.retrieveDesign);
		Init.emitter.on(APP_EVT.SHOW_DESIGN_LIST_MODAL, this.showDesignListModal);
		Init.emitter.on(APP_EVT.RETRIEVE_DESIGN_LIST, this.retrieveDesignList);

		Init.emitter.on(APP_EVT.LIST_SUCCESS, this.listSuccess);

		Init.emitter.on(APP_EVT.SAVE_SUCCESS, this.updateDesignMeta);
		Init.emitter.on(APP_EVT.RETRIEVE_DESIGN_BY_ID, this.retrieveDesignById);


		Init.emitter.on(APP_EVT.VIEW_3D, this.view3d);
		//Init.emitter.on(APP_EVT.SET_GTAG, this.setGtag);

		$('#design-list').on('click', '.design-list-row', function (this, event: Event) {

			if ($(this).hasClass('disabled')) {
				event.stopPropagation()
				return false
			}
			let design_id: string = $(this).data('id');
			let source: string = 'www';

			Init.emitter.emit(APP_EVT.RETRIEVE_DESIGN_BY_ID, design_id, source);

			$('#modal-design-list').modal('hide');

		});

		$('#btn-retrieve-design-list').on('click', function (this) {

			let email = $('#user-email').val();

			Init.emitter.emit(APP_EVT.RETRIEVE_DESIGN_LIST, email);

		});

	}


	/**
	 *
	 */
	showDesignListModal = (): void => {

		let modal: string = '#modal-design-list';

		$(modal).modal('toggle');

		let email_address: string = localStorage.getItem('email_address');

		if (email_address != '') {
			$('#retrieve-user-email').val(email_address);
			this.retrieveDesignList();
		} else {
			$('#retrieve-user-email').trigger('focus');
		}
	};


	/**
	 *
	 */
	retrieveDesignList = (): void => {

		let data: any = {};

		data.series_id = Init.series_id;
		data.email_address = $('#retrieve-user-email').val();

		$.ajax({
			type: 'POST',
			url: '/data/list',
			dataType: 'json',
			data: data
		})
			.done(function (data) {
				Init.emitter.emit(APP_EVT.FLASH_SUCCESS, data);
			})
			.fail(function (data) {
				Init.emitter.emit(APP_EVT.FLASH_ERROR, data);
			})
			.always(function (data) {
				Init.emitter.emit(APP_EVT.LIST_SUCCESS, data);
			});

	};


	/**
	 *
	 * @param data
	 */
	listSuccess = (data): void => {

		let modal: string = '#modal-design-list';

		let str = `<table class="table table-hover table-sm">
        <thead><tr>
        <th style="width:60%">design name</th>
        <th style="width:10%">quote</th>
        <th class="text-end" colspan="2" style="width:30%">design date</th>
        </tr></head>`;

		//console.log(data);

		if (data.length) {

			for (let i of data) {

				let quote_icon: string = (i.quote_id == null)
					? '<i class="material-icons md-dark md-inactive">remove</i>'
					: '<i class="material-icons quoted" data-bs-toggle="tooltip" data-bs-placement="right" title="you have requested a quote">check_circle</i>';

				let status: string = 'disabled';

				if (i.app_version != null) {
					let app_version: string[] = i.app_version.split('-');
					//console.log(app_version);
					status = (!app_version[0] || app_version[0] != 'builder') ? 'disabled' : '';
				}
				let alert_icon: string = ''
				if (i.series_id != null) {
					//console.log(app_version);
					if (i.series_id != Init.series_id) {
						alert_icon = '<i class="material-icons quoted" data-bs-toggle="tooltip" data-bs-placement="left" title="this design was created in a different design tool">fmd_bad</i>'
						status = 'disabled';
					} else {
						status = '';
					}
				}


				str += `<tr class="design-list-row ${status}" data-id="${i.id}">
                <td>${alert_icon}${i.design_id}</td>
                <td>${quote_icon}</td>
                <td class="text-end">${i.design_date_view}</td>
                <td class="text-end">${i.design_time_view}</td></tr>`;

			}

		} else {

			str += '<tr class="design-list-row"><td colspan="3">no designs found for this user</td></tr>';

		}
		str += '</table>';

		$(modal + ' #design-list').html(str);

		$(modal + ' .quoted').tooltip();

	};


	protected findOrphanItems = (): string[] => {

		let result: string[] = [];

		for (let [itemId, item] of Init.set_design.items) {

			if (item.firstPrnt == undefined
				&& [String(ITEM_TYPE.DRAGGABLE),
					String(ITEM_TYPE.PLAYHOUSE),
					String(ITEM_TYPE.STRUCTURE),
					String(ITEM_TYPE.CURVED_CLIMBER)].indexOf(item.itemType) == -1) {
				result.push(item.itemName);
			}
		}

		return result;
	};


	/**
	 *
	 * @param design_name
	 * @param email_address
	 */
	protected saveDesign = (design_name: string, email_address?: string): void => {

		//let result: boolean = true;

		//console.log('save', Init.series_id);
		Init.emitter.emit(APP_EVT.HIDE_OPTION_STATES);

		Init.set_design.setDesignName(design_name);


		Init.set_design.removeUnplacedItem();

		let data: any = {};
		let items: any = {};
		let three: Array<any> = [];
		let item_list: Map<string, Attachable> = Init.set_design.items;

		// this is needed so that Curved Climbers can get the correct seriesId of 23
		data.seriesId = (Init.line.getSeriesId) ? Init.line.getSeriesId : Init.series_id

		data.designName = design_name;
		data.emailAddress = email_address;
		//data.seriesId = Init.series_id;
		data.packlistData = '';
		data.appVersion = Init.app_file_name;
		data.authUserId = Init.user_auth_id;
		data.app_role = Init.app_role;

		if (Init.app_role == APP_ROLE.LIBRARY) {

			data.user_name = email_address;
			data.status = ($('#library-design-approved').prop('checked')) ? 1 : 0;

		}

		data.overwriteOkay = true;

		let inc = 0;

		for (let item of item_list.values()) {

			items[inc++] = item.getSaveData2d();

			three = three.concat(item.getSaveData3d());

			Debug.addToList(item);

		}

		// the Frolic ground stabilizers are not associated with specific parent items as they can be
		// attached to more than one, so they are parent-less and need to be added to packlist
		// and 3D data etc. separately from the onstage items above.
		if (Init.series_id == SERIES_ID.FROLIC) {

			three = three.concat(Init.line.getSaveData3d());

		}

		let bbox: svgjs.Box = this._stage.bbox();
		let meta: {} = Init.line.getDesignMeta();

		let designData: DesignData = {
			setScale: Init.design_scale,
			setX: Math.round(bbox.cx),
			setY: Math.round(bbox.cy),
			notes: Init.design_notes.getNotes(),
			meta: meta,
			items: items
		};

		let threeData: DesignData = {
			setScale: Init.design_scale,
			setX: Math.round(bbox.cx),
			setY: Math.round(bbox.cy),
			meta: meta,
			items: three
		};

		//console.log(three);

		JSON.stringify(designData);
		data.designData = JSON.stringify(designData);

		// packlist should be generated after all 2D an 3D codes run so that we can resolve all
		// collisions, merges etc - eg: single vs: double yardarms. Variables for these items
		// will be generated when the 2D/3D codes run, which we can then collect here.
		let packlist: any = Init.design_codes.getItemCodes().packlist;
		data.packlistData = packlist.toString();

		data.threeData = JSON.stringify(threeData);

		Debug.publish();

		$('#modal-save').fadeOut();
		$('#modal-save #btn-save-over-yes').trigger('blur')
		$('#btn-modal-save').removeClass('btn-active')

		$.ajax({
			type: 'POST',
			url: '/data/save',
			dataType: 'json',
			data: data
		})
			.done(function (data) {
				Init.emitter.emit(APP_EVT.FLASH_SUCCESS, data);
			})
			.fail(function (data) {
				Init.emitter.emit(APP_EVT.FLASH_ERROR, data);
			})
			.always(function (data) {
				Init.emitter.emit(APP_EVT.SAVE_SUCCESS, data);
			});

	};


	/**
	 * handle save result
	 *
	 *
	 */
	updateDesignMeta = (data: any): void => {

		if (data.design_source != CONST.CATALOG) {

			Init.design_timestamp = data.timestamp
			Init.set_design.setDesignName(data.design_name)
			Init.design_id = data.design_id

			if (Init.app_role == APP_ROLE.LIBRARY) {

				setTimeout(function () {
					$(document.activeElement).trigger('blur')
					$('#modal-library-save').delay(1000).modal('hide')
				}, 1000)


			} else {

				$('#modal-save #btn-save-over-yes').trigger('blur')
				$('#modal-save').modal('hide')

			}
		}
	};


	createAlert = (msg: string): string => {

		return '<div class="alert alert-warning" role="alert">' + msg + '</div>';

	}


	/**
	 *
	 */
	retrieveDesign(design_name: string): void {

		let data: any = {};
		data.design_name = design_name;

		$.ajax({
			type: 'POST',
			url: '/data/retrieveByName',
			dataType: 'json',
			data: data
		})
			.done(function (data) {
				Init.emitter.emit(APP_EVT.FLASH_SUCCESS, data);

				if (Init.app_location == APP_LOCATION.WWW) {
					Init.emitter.emit(APP_EVT.SET_GTAG, 'open_customer_design');
				}
			})
			.fail(function (data) {
				Init.emitter.emit(APP_EVT.FLASH_ERROR, data);
			})
			.always(function (data) {
				Init.emitter.emit(APP_EVT.RETRIEVE_SUCCESS, data);
			});


		$('#modal-retrieve').modal('hide');
		$('#btn-modal-retrieve').removeClass('btn-active');

	};

	/**
	 * called via events, only for www users
	 * @param tag
	 */
	// setGtag(tag: string): void {
	//
	// 	if (Init.env != 'local') {
	//
	// 		gtag('event', tag, {
	// 			'event_category': Init.line_name,
	// 			'event_label': Init.design_name,
	// 			'value': 1
	// 		});
	// 	}
	// }


	/**
	 *
	 * @param design_id
	 * @param source
	 */
	retrieveDesignById = (design_id: string, source: string): void => {

		let data: any = {};

		//console.log(design_id);

		data.design_id = design_id;
		data.source = source;

		$.ajax({
			type: 'POST',
			url: '/data/retrieveById',
			dataType: 'json',
			data: data
		})
			.done(function (data) {
				Init.emitter.emit(APP_EVT.FLASH_SUCCESS, data);
			})
			.fail(function (data) {
				Init.emitter.emit(APP_EVT.FLASH_ERROR, data);
			})
			.always(function (data) {
				Init.emitter.emit(APP_EVT.RETRIEVE_SUCCESS, data);
			});

		$('#modal-retrieve').fadeOut();
		$('#tool-btns button').removeClass('btn-active');

	}


	/**
	 *
	 */
	view3d = (): void => {

		let strWinProp: string = 'toolbar=no,'
			+ 'location=no,'
			+ 'directories=no,'
			+ 'status=no,'
			+ 'menubar=no,'
			+ 'resizeable=no,'
			+ 'scrollbars=no,'
			+ 'titlebar=yes,'
			+ 'width=1200,height=800'

		if (Init.app_role == APP_ROLE.LIBRARY) {

			window.open(Init._3D_url + '/viewer/' + Init.series_id + '/' + Init.design_id + '/library', 'cd_3d', strWinProp)

		} else if (Init.design_id == '' || Init.design_timestamp == null) {

			let modal: string = '#modal-blank'
			$(modal + ' #msg').text('please save the design before viewing in 3D')
			$(modal).modal('show')

		} else {

			let role: string = (Init.app_role == APP_ROLE.LIBRARY) ? 'library' : 'viewer'

			window.open(Init._3D_url + '/' + role + '/' + Init.series_id + '/' + Init.design_id, 'cd_3d', strWinProp)
		}
	}

	/** **************************************************************
	 *                                   GETTERS - SETTERS
	 */

}

export {
	DataBase
}

